import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Img } from '@alfa-bank/site-img';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { IconBlockDesktop as IconBlock } from '../components/icon-block/desktop';
import { SecurityContentBlockDesktop as SecurityContentBlock } from '../components/security-content-block/desktop';
import { SecurityWarrantyBlockDesktop as Component } from '../layouts/desktop';
import type { IDepsDesktop, TSecurityBlockComponentDesktop } from '../models';

import styles from './styles.css';

export const SecurityWarrantyBlockDesktop = createWidget<
    IDepsDesktop,
    TSecurityBlockComponentDesktop
>({
    Block,
    Button,
    IconBlock,
    Img,
    sendEvent,
    SecurityContentBlock,
    styles,
})(Component);
